<common-mojo-card class="container-card">

  <div class="container-pater">
    <div class="row">
      <div
        class="col-12 mt-mobile"
        [ngClass]="{'col-md-4': isOfferDisplayed | async, 'col-md-6': (isOfferDisplayed | async) === false}"
      >
        <mojo-pie-char-average
          *ngIf="(selectReportsDashboardLoaded$ | async); else loading"
          [elementsPieChar]="selectReportsDashboard$ | async"
          [titleInput]="'DIRECT APPLICANTS'"
        >
        </mojo-pie-char-average>

        <ng-template #loading>
          <div class="d-flex justify-content-center">
            <mat-spinner
              [diameter]="48"
              [strokeWidth]="4"
              class="loader"
            ></mat-spinner>
          </div>
        </ng-template>
      </div>

      <div
        class="col-12 mt-mobile"
        [ngClass]="{'col-md-4': isOfferDisplayed | async, 'col-md-6': (isOfferDisplayed | async) === false}"
      >
        <mojo-pie-char-average
          *ngIf="(selectReportsDashboardSubmissionLoaded$ | async); else loadingSubmission"
          [elementsPieChar]="selectReportsDashboardSubmission$ | async"
          [titleInput]="'HIRING MANAGERS SUBMISSIONS'"
        >
        </mojo-pie-char-average>

        <ng-template #loadingSubmission>
          <div class="d-flex justify-content-center">
            <mat-spinner
              [diameter]="48"
              [strokeWidth]="4"
              class="loader"
            ></mat-spinner>
          </div>
        </ng-template>

      </div>
      <div
        class="col-12 mt-mobile"
        [ngClass]="{'col-md-4': isOfferDisplayed | async, 'col-md-6': (isOfferDisplayed | async) === false}"
        *mojoHasFeatureExtension="dashboardDisplayOffer"
      >
        <mojo-pie-char-average
          *ngIf="(selectReportsDashboardOfferLoaded$ | async); else loadingOffer"
          [elementsPieChar]="selectReportsDashboardOffer$ | async"
          [titleInput]="'OFFER'"
          [showAverages]="false"
        >
        </mojo-pie-char-average>

        <ng-template #loadingOffer>
          <div class="d-flex justify-content-center">
            <mat-spinner
              [diameter]="48"
              [strokeWidth]="4"
              class="loader"
            ></mat-spinner>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</common-mojo-card>
